import { render, staticRenderFns } from "./Create-Contract.vue?vue&type=template&id=775fee5a"
import script from "./Create-Contract.vue?vue&type=script&lang=js"
export * from "./Create-Contract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports